module.exports = __webpack_public_path__ + "img/Zeppa_DX.244a80a6.png";